// ความสำเร็จทั้งหมด ได้แล้วขึ้นก่อน ความสำเร็จลับไม่บอกเงื่อนไขจนกว่าจะได้ (docs/PLAN.md เฟส 3)

import { ACHIEVEMENTS, type AchievementDef, type AchievementState } from "../../shared/achievements";
import type { Dex } from "../../shared/dex";
import { fmt } from "../names";

interface Props {
  achievements: AchievementState;
  dex: Dex;
  onBack: () => void;
}

const thaiDate = (iso: string) => new Date(iso).toLocaleDateString("th-TH", { day: "numeric", month: "short", year: "2-digit" });

function Item({ a, date, dex }: { a: AchievementDef; date?: string; dex: Dex }) {
  const secret = a.hidden && !date;
  const progress = !date && a.progress?.(dex);
  return (
    <li className={date ? "card achievement got" : "card achievement"}>
      <p>
        <b>{secret ? "ความสำเร็จลับ" : a.nameTh}</b>
        {date && <span className="small muted"> · ได้เมื่อ {thaiDate(date)}</span>}
      </p>
      <p className="small muted">{secret ? "เล่นต่อไปแล้วจะรู้เอง" : a.description}</p>
      {progress && progress[0] > 0 && (
        <p className="small">
          <progress max={progress[1]} value={progress[0]} /> {fmt(progress[0])}/{fmt(progress[1])}
        </p>
      )}
    </li>
  );
}

export function Achievements({ achievements, dex, onBack }: Props) {
  const got = ACHIEVEMENTS.filter((a) => achievements.unlocked[a.id]);
  const rest = ACHIEVEMENTS.filter((a) => !achievements.unlocked[a.id]);
  return (
    <main className="screen">
      <section className="card">
        <h1 style={{ fontSize: "1.4rem" }}>ความสำเร็จ</h1>
        <p>
          ได้แล้ว <b>{fmt(got.length)}</b> จาก {fmt(ACHIEVEMENTS.length)}
        </p>
        <p className="small muted">เก็บไว้ในเบราว์เซอร์นี้เท่านั้น เหมือนสมุดสัตว์</p>
      </section>
      <ul className="achievement-list">
        {[...got, ...rest].map((a) => (
          <Item key={a.id} a={a} date={achievements.unlocked[a.id]} dex={dex} />
        ))}
      </ul>
      <div className="actions">
        <button className="btn block" onClick={onBack}>
          กลับหน้าแรก
        </button>
      </div>
    </main>
  );
}
